import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ChevronUp } from 'lucide-react';

export const ScrollToTop: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return showScrollTop ? (
    <Button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 rounded-full bg-[#D1F551] p-3 text-black shadow-lg hover:bg-[#B7D257] transition-all duration-300"
      size="icon"
    >
      <ChevronUp className="h-6 w-6" />
    </Button>
  ) : null;
};
